"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCampaignMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.UpdateCampaignMessageSchema = typebox_1.Type.Object({
    campaignId: core_1.IdSchema,
    teamId: core_1.IdSchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
    organisationRef: ruby_1.AppleProxyOrgRefSchema,
    applicationRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    country: core_1.CountrySchema,
    from: core_1.TimestampSchema,
});
